import ContentMainContainer from "@/containers/Content/ContentMainContainer";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const description =
    "필수 장례 가이드와 죽음에 관하여 콘텐츠로 설명해드려요. 장례 전 준비해야하는 것, 임종 전 필요한 정보와 죽음과 관련된 다양한 이야기까지 확인해보세요.";
  return {
    props: {
      pageOgTitle: `고이 피드, 장례와 죽음에 관하여 콘텐츠로 설명해드려요 | 고이 프라임`,
      pageDescription: description,
      pageKeywords: `죽음에 관하여, 장례, 임종`,
      pageOgDescription: description,
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/direct/content/main-hero.png.png`,
    },
  };
};

export default function ContentMain() {
  return <ContentMainContainer />;
}
